import { render, staticRenderFns } from "./FundsMgmtSettings.vue?vue&type=template&id=3d314460"
import script from "./FundsMgmtSettings.vue?vue&type=script&lang=js"
export * from "./FundsMgmtSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports